
import { defineComponent, ref } from "vue";

const ButtonClickAdd = defineComponent({
  name: "Button Click Add",
  setup() {
    let count = ref(0);

    const clickAdd = (): void => {
      count.value++;
    };

    return { clickAdd, count };
  },
});
export default ButtonClickAdd;
